import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=f5f58e38&scoped=true&"
import script from "./file-input.vue?vue&type=script&lang=js&"
export * from "./file-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f58e38",
  null
  
)

export default component.exports